"use client";

import React from "react";
import { Landmark, ShieldCheck, TrendingUp } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const pillars = [{
  title: "Advanced Tax-Strategy",
  description: "Proactive tax optimization tailored for high-net-worth portfolios. We navigate complex regional and federal codes to preserve capital and enhance long-term yield.",
  icon: Landmark,
  link: "/TheCarolinasEdgePage"
}, {
  title: "Private Life Insurance",
  description: "Sophisticated risk management and liquidity solutions. Our insurance strategies are designed to secure legacies and provide stability across generations.",
  icon: ShieldCheck,
  link: "/SecureYourLegacyPage"
}, {
  title: "Comprehensive Planning",
  description: "Holistic wealth architecture that aligns investment, estate, and retirement goals. We build resilient frameworks for sustainable growth and peace of mind.",
  icon: TrendingUp,
  link: "/WealthArchitecturePage"
}];
export default function StrategicWealthPillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="strategic-wealth-pillars" ref={ref} className="dark bg-background text-foreground py-24 lg:py-32 relative overflow-hidden">
      {}
      <div className="container mx-auto px-6 md:px-12">
        <div className={cn("grid grid-cols-1 md:grid-cols-3 gap-16 lg:gap-24 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {pillars.map((pillar, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center group">
              {}
              <div className="mb-8 p-4 rounded-full border border-primary/10 bg-primary/5 shadow-[0_0_30px_-10px_var(--color-primary)]">
                <pillar.icon strokeWidth={1} className="w-12 h-12 text-primary" />
              </div>

              {}
              <h3 className="text-2xl md:text-3xl font-serif text-foreground mb-6 tracking-wide">
                {pillar.title}
              </h3>

              {}
              <p className="text-muted-foreground font-sans leading-relaxed mb-8 max-w-xs mx-auto">
                {pillar.description}
              </p>

              {}
              <div className="mt-auto">
                <Link to={pillar.link} className="inline-block text-sm uppercase tracking-widest text-primary border-b border-primary pb-1 transition-all duration-300 hover:border-b-2 hover:text-primary/90">
                  Learn More
                </Link>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}